import Airtable from "airtable";

const base = new Airtable({ apiKey: "keyQ2jqfNAEscUw7q" }).base(
  "appoe5k0FjiZbW6Zc"
);

export default base;
